
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6dd39339!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ConfigResource.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ConfigResource.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6dd39339!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ConfigResource.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/user/ConfigResource.vue
// module id = 1019
// module chunks = 2